import $ from 'jquery'
import { formatMoney, throttle, updateQueryStringParameter } from './helpers'
import axios from 'axios'

function getProductJson(root) {
  const data = root.attr('data-product')
  const json = JSON.parse(data)
  return json
}

if ($('.gift-guide-product').length) {
  $('.gift-guide-product [name="id"]').on('change', function () {
    const rootEl = $(this).closest('.gift-guide-product')
    const json = getProductJson(rootEl)
    const variant = json.variants.find((v) => v.id.toString() === $(this).val())

    // Update image
    rootEl.find('.gift-guide-product__image img').attr('src', variant.featured_image.src)
    rootEl.find('.gift-guide-product__subtitle').html(variant.title)

    // Update price
    const url = `/products/${json.handle}?variant=${variant.id}&section_id=main-product`
    axios.get(url).then(function (pricesRes) {
      const dom = document.createElement('div')
      dom.innerHTML = pricesRes.data
      const newPrice = dom.querySelector('.product-price ').innerHTML
      rootEl.find('.price').html(newPrice)
    })
  })
}
